export const GET_CURRENT_COMPANY_ENDPOINT = '/company/getCurrentCompany';
export const GET_CURRENT_COMPANY_BANK_INFORMATION_ENDPOINT = '/company/getCurrentCompanyBankInformation';
export const CREATE_COMPANY_ENDPOINT = '/companies/create';
